<template>
	<div class="payment">
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/gong1.png" class="steps step1" v-if="status==1">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'供应商付款 '}]" />
		<div class="yx_contain">
			<div class="inner_con">
				<div class="yx_left">
					<div class="nowNomth">本月需付款</div>
					<div class="nowPay" v-if="amount > 0">{{amount}}元</div>
					<div class="conCom" style="height:4.8rem;overflow-y: auto;">
						<div class="eveCom" :class="{eveComAc:acCom == i}" v-for="(item,i) in suppers" :key="i" @click="change(i,item.supperName,item.supperCode)">
							{{item.supperName}}
						</div>
					</div>
					<div class="xuanding" v-if="yxamount > 0">
						选定付款总额：
						<span class="allmoney">{{yxamount}}元</span>
					</div>
				</div>
				<div class="yx_right">
					<div class="nowCheck">{{nowName}}</div>
					<div class="blankimg" v-if="isBlank">
						<img src="../../assets/images/mylittle.png" style="width: 100%;">
					</div>
					<div class="conList" v-else>
						<div class="eveLis" v-for="(item,i) in list" :key="item.id">
							<el-checkbox-group v-model="checkList" @change="getCheckAmount">
								<el-checkbox :label="item">
									<div class="ddNum">
										采购订单号{{item.code}}
										<span class="payStatus">
											<!--<template slot-scope="scope">-->
											<!--{{scope.item.isPayment | dictname('cgfk')}}-->
											<!--</template>-->
											{{item.isPayment|dictname('cgfk')}}
										</span>
									</div>
									<div class="containfour">
										<div>
											<div class="toptip">销售订单号</div>
											<div>{{item.orderCode||'/'}}</div>
										</div>
										<div>
											<div class="toptip">付款进度</div>
											<div>{{item.payNum}}/{{item.totalPayNum}}</div>
										</div>
										<div>
											<div class="toptip">本月应付</div>
											<div>{{item.payAmount}}</div>
										</div>
										<div>
											<div class="toptip">付款单号</div>
											<div>{{item.paymentOrderNo||'/'}}</div>
										</div>
									</div>
									<brupload v-if="item.isNeedcred == 1" :refid="item.id" :reftype=cgfkpz uploadflag delflag @filecallback=addfilecallbackpo>
									</brupload>
								</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="h-txtCenter h-mrt60">
			<el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
			<el-button class="h-btn h-bBtn h-bgblueQ2" @click="sumitfk">确认提交</el-button>
		</div>
	</div>
</template>

<script>
	import big from 'big.js'
	import ss from '../../api/SystemService';
	import _ from 'lodash';
	export default {
		name: "payment",
		data() {
			return {
				toshow: 'orderCgPayment',
				checked: true,
				showOrhide: false,
				status: 1,
				// company:[{name:'弄阿斯弗'},{name:'asdhasoh弄121212121212121212阿斯弗'},{name:'asdhasoh弄阿斯弗'},{name:'弄阿斯弗'},{name:'asdhasoh弄阿斯弗'},{name:'asdhasoh弄阿斯弗'},{name:'斯弗'},{name:'弄阿斯弗'},{name:'asdsda啊沙发上soh弄阿斯弗'},{name:'asdh斯弗'},{name:'asdhasoh弄阿斯弗'}],
				list: [],
				acCom: null,
				nowName: '',
				checkList: [],
				isBlank: true, //右侧无数据展示空盒子
				amount: '',
				supperCode: '',
				suppers: [],
				fileList: [],
				yxamount: '',
				cgfkpz: 'cgddfkpz',
			}
		},
		computed: {},
		props: {},
		mounted() {
			//获取总金额
			this.getAmount("");
			//获取供应商列表
			this.getSupLists();
		},
		created() {
			this.showzhezhao()
		},
		methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
						document.documentElement.scrollTop = 500
				    }
				})
			},
			closeIt() {
				this.showOrhide = false;
				if (this.checked) {
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},
			nextStep(i) {
				console.log(i)
				if (this.status == 1) {
					if (this.checked) {
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}

				}
			},
			change(i, n, code) {
				this.acCom = i;
				this.nowName = n;
				this.getOrderCgFuKList(code);
				this.isBlank = false;
			},
			getAmount(v) {
				this.supperCode = v;
				ss.orderCgService.selectBySCode(this.supperCode).then(rd => {
					if (rd.f) {
						this.amount = rd.obj;
					}
				})
			},
			getSupLists() {
				ss.orderCgService.selectSupLists().then(rd => {
					if (rd && rd.length > 0) {
						this.suppers = rd;
					}
				})
			},
			getOrderCgFuKList(v) {
				ss.orderCgService.selectOrderCgFuKList(v).then(rd => {
					if (rd && rd.length > 0) {
						this.list = rd;
					}
				})
			},
			getCheckAmount() {
				var amount = 0;
				this.checkList.forEach(function(item, key) {
					// amount += item.payAmount
					amount = new big(amount).plus(item.payAmount);
				})
				this.yxamount = amount;
			},
			cancel() {
				this.$router.push("purchaselist");
			},
			sumitfk() {
				if (!this.checkList || this.checkList < 1) {
					this.$msg.msge("请选择付款采购订单！");
					return;
				}
				var flag = false;
				this.checkList.forEach(function(item, key) {
					if (item.isPayment == 1) {
						flag = true;
						return false;
					}
				})
				if (flag) {
					this.$msg.msge("付款中采购订单不能重复付款！");
					return;

				}
				ss.orderCgService.saveCgFk(this.checkList).then(rd => {
					if (rd.f) {
						this.$msg.msgs(rd.msg);
						this.$router.push("purchaselist");

					} else {
						this.$msg.msge(rd.msg);
					}
				})
			},
			addfilecallbackpo(v) {
				var list = this.list;
				_.forEach(this.list, function(item, key) {
					_.forEach(v, function(item1) {
						if (item1.refid == item.id && item1.reftype == "cgddfkpz") {
							list[key].pzfileFlag = 1;
							return false;
						}
					})
				})
				this.list = list;
			}
		}
	}
</script>

<style scoped lang="scss">
	.yx_contain {
		padding: 0.22rem 0.38rem 0 0.32rem;

		.inner_con {
			display: flex;
			justify-content: space-between;

			.yx_left {
				width: 6.6rem;
				height: 6.9rem;
				background-color: white;
				padding: 0.4rem 0.2rem;
				text-align: center;
				position: relative;
				color: #6f7376;

				.nowNomth {
					font-size: 0.18rem;
				}

				.nowPay {
					font-size: 0.4rem;
					font-weight: bold;
					margin-top: 0.22rem;
				}

				.conCom {
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
					/*height: 3.2rem;*/
					overflow-y: auto;
					margin-top: 0.6rem;

					.eveCom {
						display: inline-block;
						height: 0.58rem;
						color: #0c78e7;
						border: 2px solid #0c78e7;
						border-radius: 2px;
						padding: 0rem 0.23rem;
						line-height: 0.58rem;
						font-size: 0.18rem;
						margin-right: 0.2rem;
						margin-bottom: 0.2rem;
						cursor: pointer;
					}

					.eveComAc {
						color: white;
						background-color: #0c78e7;
					}
				}

				.xuanding {
					position: absolute;
					bottom: 0.3rem;
					left: 0;
					width: 100%;
					font-size: 0.2rem;
					color: #9a9a9a;
					text-align: right;

					.allmoney {
						color: #0e76e9;
						font-size: 0.32rem;
						padding-right: 0.2rem;
					}
				}
			}

			.yx_right {
				width: 9.14rem;
				height: 6.9rem;
				padding: 0.3rem 0.5rem;

				background-color: white;

				.nowCheck {
					font-size: 0.18rem;
					font-weight: bold;
					color: #0c78e7;
					letter-spacing: 2px;
					height: 0.4rem;
				}

				.conList {
					height: 5.6rem;
					width: 100%;
					overflow-y: auto;

					.eveLis {
						font-size: 0.18rem;
						border-bottom: 1px solid #dae1e9;
						padding-bottom: 0.2rem;
						position: relative;
						padding-top: 0.2rem;
						margin-bottom: 0.2rem;
						color: #2b2b2b;

						.containBox {
							position: absolute;
							left: 0;
							top: 50%;
							transform: translateY(-60%);
						}

						.ddNum {
							margin-bottom: 0.18rem;
							position: relative;

							.payStatus {
								padding: 0.03rem 0.2rem;
								border: 1px solid #0c78e7;
								border-radius: 0.6rem;
								color: #0c78e7;
							}
						}

						.containfour {
							display: flex;
							width: 100%;
							justify-content: space-between;

							.toptip {
								margin-bottom: 0.18rem;
							}
						}
					}
				}
			}
		}
	}
</style>
<style>
	.conList .el-checkbox {
		width: 100%;
	}

	.conList .el-checkbox__label {
		width: 95%;
	}
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;

		}

		.steps {
			position: absolute;
			z-index: 1;

		}

		.step1 {
			top: 6.25rem;
			left: 10.25rem;
			width: 3.1rem;
			height: 2rem;
		}

		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
